import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { fixRouteParam } from '@src/utils';
import { PagesService } from '@src/app/modules/pages';
import { PermissionService } from '@src/app/modules/pages/page-info/services';
import { PageInfoMode } from '@src/app/modules/pages/page-info';

@Component({
  selector: 'pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss', '../styles/administration-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagesComponent extends BaseResizableComponent {
  private readonly pagesService = inject(PagesService);
  private readonly permService = inject(PermissionService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  readonly pagesList$ = this.pagesService.pagesList$;
  selectedPageId?: string;
  pageInfoMode: PageInfoMode = 'none';

  readonly allowCreating$ = this.permService.allowCreating$;

  get showFullPage(): boolean {
    return this.pageInfoMode === 'none';
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.getData();

    this.activatedRoute.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(params => {
      this.selectedPageId = fixRouteParam(params.get('pageId'));
      if (this.selectedPageId) {
        this.pageInfoMode = 'view';
      }
    });
  }

  onChangeSelectedPageId(selectedPageId?: string) {
    this.selectedPageId = selectedPageId;
    this.pageInfoMode = this.selectedPageId ? 'view' : 'none';

    const routerNavigate = ['settings/administration/pages'];
    if (selectedPageId) {
      routerNavigate.push(selectedPageId);
    }
    this.router.navigate(routerNavigate);
  }

  onClickReturnButton() {
    this.onChangeSelectedPageId(undefined);
  }

  onClickAddButton() {
    this.selectedPageId = undefined;
    this.pageInfoMode = 'create';
    this.cdr.markForCheck();
  }

  onDeleted() {
    this.onClickReturnButton();
    this.reload();
  }

  reload() {
    this.getData();
  }

  private getData(): void {
    this.pagesService.resetPagesList();
    this.pagesService.getPagesList();
    this.pagesService.getPagesForNavigation();
    this.cdr.markForCheck();
  }
}
